module.exports = __webpack_public_path__ + "static/media/mshtml_32550.81e73ff2.ico";